import { cloudinaryInstance, ppmvInstance } from "api";

export const submitPPMVSurvey = async (payload) => {
	return await ppmvInstance.post("/survey/create/ppmv", payload);
};

export const uploadToCloudinary = async (file, folderName) => {
	if (!file) {
		console.log("No image file selected");
		return;
	}

	const formData = new FormData();

	formData.append("file", file);
	formData.append("upload_preset", "sngtech-media-preset");
	formData.append("folder", `ppmv-survey/${folderName}`);

	try {
		const response = await cloudinaryInstance.post(
			`/image/upload`,
			formData
		);
		return response.data.secure_url;
	} catch (error) {
		console.error("Error uploading file:", error);
	}
};
